/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */
import _ from 'lodash';

import { parseServerDateTime, formatDisplayDate } from '@/util/MomentUtils';
import cleanUpResponse from '@/util/cleanUpResponse';

export default async function SearchAssetProblems(parameters) {
  const response = await $.soap({
    body: {
      SearchAssetProblems: {
            $xmlns: 'http://dla.mil/ems/bpm/asset_problem',
            SerialNumber: parameters?.serialNumber,
            ContractNumber: parameters?.contractNumber,
            StatusID: parameters?.statusId,
            CreatedOnStart: parameters?.createdOnStart,
            CreatedOnEnd: parameters?.createdOnEnd
        }
    },

    blueprintArrays: ['SearchAssetProblemsResponse.Response.tuple.old.rowset.row'],
    blueprint: {
      totalCount: '$..TotalCount',
      assetProblems: [
        '$..old.rowset.row',
        {
          id: '$.ID',
          serialNumber: '$.SerialNumber',
          contractNumber: '$.ContractNumber',
          description: '$.Description',
          statusId: '$.StatusID',
          problemStatus: '$.ProblemStatus',
          createdOn: '$.CreatedOn',
          resolvedOn: '$.ResolvedOn'
        }
      ]
    }
  });

  _.each(response.assetProblems, (prob) => {
    prob.createdOn = formatDisplayDate(parseServerDateTime(prob.createdOn))
  })

  if (!response.totalCount) {
    response.totalCount = 0;
  }

  cleanUpResponse(response);
  return response;
}
